<script setup lang="ts">
    import GamesDisplay from '@/components/games/GamesDisplay.vue';
</script>

<template>
  <GamesDisplay/>
</template>
